/* ==========================================================================
  main.js
========================================================================== */

'use strict';
/* global fitvids, cssVars */

/**
 * Init responsive videos
 */
fitvids();

/**
 * Init CSS vars ponyfill
 */
cssVars({});

const setFoCo = (name, value, days = 60) => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value || ''}${expires}; path=/`;
};

function populateMostRecentUTMMedium() {
  try {
    const params = new URLSearchParams(location.search);
    const maybeUTMMedium = params.get("utm_medium");
    if (maybeUTMMedium) {
      setFoCo("most_recent_utm_medium", maybeUTMMedium);
    }
  } catch (err) {
    console.log("UTMM fail");
  }
}

function populateMarketingIdentifiers() {
  try {
    const doit = async () => {
      let platformName = null;
      let campaignId = null;
      let adGroupId = null;
  
      const params = new URLSearchParams(location.search);
      const utmSource = params.get("utm_source");
      const utmMedium = params.get("utm_medium");
      const utmCampaign = params.get("utm_campaign");
      const adgroupId = params.get("adgroup_id");
  
      if (utmSource && utmMedium) {
        platformName = `${utmSource}+${utmMedium}`;
      } else if (utmSource) {
        platformName = utmSource;
      } else if (utmMedium) {
        platformName = utmMedium;
      }

      if (utmCampaign) {
        campaignId = await getHashedValue(utmCampaign);
      }
      if (adgroupId) {
        adGroupId = await getHashedValue(adgroupId);
      }

      if (platformName) {
        setFoCo("summarum_pfn", platformName);
      }
      if (campaignId) {
        setFoCo("summarum_cid", campaignId);
      }
      if (adGroupId) {
        setFoCo("summarum_adgid", adGroupId);
      }
    }
    
    doit();
  } catch (err) {}
}

function isFromOrganicSearch() {
  try {
    // Check if document.referrer is available
    if (!document.referrer) {
        return false;
    }
  
    // Parse the referrer URL
    const url = new URL(document.referrer);
  
    // Check if the host is a Google or Bing domain
    const isGoogleOrBing = /\.(google|bing)\.(com|[a-z]{2,3}(\.[a-z]{2})?)$/.test(url.hostname);
    if (!isGoogleOrBing) {
        return false;
    }
  
    // Check for search query parameters
    const hasSearchQuery = url.searchParams.has('q') || url.searchParams.has('p');
    if (!hasSearchQuery) {
        return false;
    }
  
    // Check for the absence of ad-related parameters
    const hasAdParameters = url.searchParams.has('gclid') || 
                            url.searchParams.has('aclid') ||
                            url.searchParams.has('msclkid');
    if (hasAdParameters) {
        return false;
    }
  
    // If all conditions are met, it's likely an organic search
    return true;
  } catch (err) {
    console.error(err);
    return false;
  }
}

document.addEventListener('DOMContentLoaded', function () {
  try {
    const yyyy = new Date().getFullYear();
    let mm = new Date().getMonth() + 1;
    if (mm < 10) {
      mm = `0${mm}`;
    }
    let dd = new Date().getDate();
    if (dd < 10) {
      dd = `0${dd}`;
    }
    let hh = new Date().getHours();
    if (hh < 10) {
      hh = `0${hh}`;
    }
    let min = new Date().getMinutes();
    if (min < 10) {
      min = `0${min}`;
    }
    let sec = new Date().getSeconds();
    if (sec < 10) {
      sec = `0${sec}`;
    }
    const timeAsYYYYMMDDHIS = `${yyyy}-${mm}-${dd} ${hh}:${min}:${sec}`;

    const storeCookies = () => {
      const queryParameters = new URLSearchParams(window.location.search);

      if (queryParameters.has("at_gd")) {
        setFoCo("summarum_at_gd", queryParameters.get("at_gd"));
        setFoCo("summarum_at_gd_timestamp", timeAsYYYYMMDDHIS);
      }
      
      // msclkid
      if (queryParameters.has("msclkid")) {
        setFoCo("summarum_msclkid", queryParameters.get("msclkid"));
        setFoCo("summarum_msclkid_timestamp", timeAsYYYYMMDDHIS);
      }

      // gbraid
      if (queryParameters.has("gbraid")) {
        setFoCo("summarum_gbraid", queryParameters.get("gbraid"));
        setFoCo("summarum_gbraid_timestamp", timeAsYYYYMMDDHIS);
      }

      // wbraid
      if (queryParameters.has("wbraid")) {
        setFoCo("summarum_wbraid", queryParameters.get("wbraid"));
        setFoCo("summarum_wbraid_timestamp", timeAsYYYYMMDDHIS);
      }

      // pa_clickid
      if (queryParameters.has("pa_clickid")) {
        setFoCo("summarum_pa_clickid", queryParameters.get("pa_clickid"));
        setFoCo("summarum_pa_clickid_timestamp", timeAsYYYYMMDDHIS);
      }

      // tblci
      if (queryParameters.has("tblci")) {
        setFoCo("summarum_tblci", queryParameters.get("tblci"));
        setFoCo("summarum_tblci_timestamp", timeAsYYYYMMDDHIS);
      }

      // ra_clickid
      if (queryParameters.has("ra_clickid")) {
        setFoCo("summarum_ra_clickid", queryParameters.get("ra_clickid"));
        setFoCo("summarum_ra_clickid_timestamp", timeAsYYYYMMDDHIS);
      }

      // ttclid
      if (queryParameters.has("ttclid")) {
        setFoCo("summarum_ttclid", queryParameters.get("ttclid"));
        setFoCo("summarum_ttclid_timestamp", timeAsYYYYMMDDHIS);
      }

      // gclid
      if (queryParameters.has("gclid")) {
        setFoCo("summarum_gclid", queryParameters.get("gclid"));
        setFoCo("summarum_gclid_timestamp", timeAsYYYYMMDDHIS);
      }

      // fbc 
      if (queryParameters.has("fbclid")) {
        setFoCo("summarum_fbc", queryParameters.get("fbclid"));
        setFoCo("summarum_fbc_timestamp", timeAsYYYYMMDDHIS);
      }

      // organic_search_landing_page_url
      if (isFromOrganicSearch()) {
        setFoCo("summarum_organic_search_landing_page_url", window.location.href);
        setFoCo("summarum_organic_search_landing_page_url_timestamp", timeAsYYYYMMDDHIS);
      }
    };

    storeCookies();
    populateMostRecentUTMMedium();
    populateMarketingIdentifiers();
  } catch (err) {}

  try {
    // Check if the site is the South African one
    if (window.location.hostname.includes('creditum.co.za')) {
      // Create the back to top button
      const backToTopButton = document.createElement('button');
      backToTopButton.innerHTML = '&uarr;'; // Up arrow
      backToTopButton.setAttribute('id', 'back-to-top');
      backToTopButton.setAttribute('title', 'Back to top');
      document.body.appendChild(backToTopButton);

      // Style the button
      backToTopButton.style.position = 'fixed';
      backToTopButton.style.bottom = '20px';
      backToTopButton.style.right = '20px';
      backToTopButton.style.width = '50px';
      backToTopButton.style.height = '50px';
      backToTopButton.style.borderRadius = '50%';
      backToTopButton.style.backgroundColor = '#007bff';
      backToTopButton.style.color = 'white';
      backToTopButton.style.border = 'none';
      backToTopButton.style.fontSize = '20px';
      backToTopButton.style.cursor = 'pointer';
      backToTopButton.style.display = 'none';
      backToTopButton.style.zIndex = '1000';

      // Show/hide the button based on scroll position
      window.addEventListener('scroll', () => {
        if (window.scrollY > 300) {
          backToTopButton.style.display = 'block';
        } else {
          backToTopButton.style.display = 'none';
        }
      });

      // Scroll to top when the button is clicked
      backToTopButton.addEventListener('click', () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    }
  } catch (err) {}

  try {
    const params = new URLSearchParams(window.location.search);
    const leadgidClickid = params.get('clickid');
    const utmCampaign = params.get('utm_campaign');
    const utmSource = params.get('utm_source');
    // YYYY-MM-DD HH:MM:SS:
    const timestamp = new Date().toISOString().slice(0, 19).replace('T', ' ');

    if (window.location.hostname.includes('creditum.co.za')) {
      if (leadgidClickid && !!utmCampaign && utmCampaign.toLowerCase().includes('6557')) {
        setFoCo('leadgid_click_id', `FIXED_CPL${leadgidClickid}`, { expires: 30 });
        setFoCo('leadgid_click_timestamp', timestamp, { expires: 30 });
      } else {
        setFoCo('leadgid_click_id', leadgidClickid, { expires: 30 });
        setFoCo('leadgid_click_timestamp', timestamp, { expires: 30 });
      }
    } else {
      if (utmSource === 'leadgid' && !!leadgidClickid) {
        setFoCo('leadgid_click_id', leadgidClickid, { expires: 30 });
        setFoCo('leadgid_click_timestamp', timestamp, { expires: 30 });
      }
    }
  } catch (err) {}
});
